<script setup lang="ts">
import type { WorkspaceDTO } from '@/types/workspace'

import RegistrationStatsDashboard from '@/components/statistics/RegistrationStatsDashboard.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresInternalAccess: true,
  },
})

defineProps<{
  workspace: WorkspaceDTO
}>()
</script>

<template>
  <RegistrationStatsDashboard :workspace-id="workspace.id" />
</template>
